import _ from "lodash";

export const validateValue = (value, field) =>
  _.isNil(value) || _.isEqual(value, "")
    ? { content: `The field ${field} cannot be empty!`, pointing: `below` }
    : false;

export const toLowerCase = text => text && text.toLowerCase();
